export const fetchCourseDetails = async (setCourseDetails, setStatusMessage, course_ID) => {
    try {
      const response = await fetch(
        "https://wad-backend.ws381566.remote.ac/getCourseDetailsAdmin.php?adminRequired=true&courseID=" + course_ID,
        {
          method: "GET",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          mode: "cors",
        }
      );
  
      const result = await response.json();
  
      if (result.status === "authenticationError") {
        window.location.href = "/login";
        return;
      }
  
      if (result.status === "success") {
        setCourseDetails(result.course);
      } else {
        setStatusMessage(result.message || "Failed to execute query");
      }
    } catch (error) {
      setStatusMessage(error.message);
    }
};